import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import CourseListBody from "./CourseListBody";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import ProgressBar from "react-bootstrap/ProgressBar";
import _ from "lodash";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import {
  getCheckListInsert,
  getCourseDetailEcom,
  getCourseDetailEcomClear,
  getCourseRelated,
  getCourseRelatedClear,
  getModuleFavGet,
  getModuleListing,
  getModuleListingBroker,
  getModuleListingClear,
  getModuleListingClearBroker,
  getMyLearningPaths,
  getMyLearningPathsClear,
  getRankStatus,
  getRankStatusClear,
  getSingleLP,
  getSingleLPClear,
  markModuleProgress,
  markModuleProgressClear,
  openHamburger,
} from "../../redux/courses/actions";
import { applyTheme, checkRankStatusFunc, clickStreamUser, convertHoursToMins, convertTimeFormat, formatLPCoursesList, getFormatCourseListFromWoo, getFormatedDataOfLPUtils, SessionKeys } from "../../utils/AppUtils";
import { ModuleComp } from "./ModuleComp";
import JSZip from "jszip";
import { Spinner } from "react-bootstrap";
import JSZipUtils from "jszip-utils";
import { saveAs } from "file-saver";
import CONFIG from "../../utils/config";
import { ModuleNotes } from "../../pages/modulePages/ModuleNotes";
import { getModulenotesGet } from "../../redux/courses/actions";
import {
  getModuleNotesDelete,
  getModuleNotesDeleteClear,
  getModuleNotesUpdate,
  getModuleNotesUpdateClear,
} from "../../redux/courses/actions";
import ModuleFav from "../../pages/modulePages/ModuleFav";
import { array } from "yup";
import CongratulationsPopUp from "./CongratulationsPopUp";
import CongPopupAnimation from "./CongPopupAnimation";
import { checkContentAccess } from "../../redux/home/actions";
import Loader from "../Loader/Loader";
import CourseCardListBody from "./CourseCardListBody";
import LPMoreLearn from "./LPMoreLearn"
import useLogin from "../../custom-hooks/useLogin";
import API_LIST from "../../utils/apiList";
import LPdetailComp from "../b2cComponents/LPDetailComp";
import AfterCongratulationsModal from "../modal/AfterCongratulationsModal";


const CourseLaunchSection = ({ isMobile }) => {
  const hamburgerMenu = useRef();
  const [showAllMenu, setShowAllMenu] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();
  // const { isLoggedIn } = useLogin();

  const iframeRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const [loaderMsg, setLoaderMsg] = useState("Please wait")
  const [activeTab, setActiveTab] = useState(1);
  const [loader, setLoader] = useState(false);
  const [courseTitle, setCourseTitle] = useState(
    location?.state?.courseTitle
  );
  const [courseProgress, setCourseProgress] = useState(
    location?.state?.courseProgress
  );
  const [selectedModule, setSelectedModule] = useState(
    location?.state?.module
  );
  const [moduleId, setModuleId] = useState(location?.state?.mId);
  const moduleListingData = useSelector((state) => state.courses.moduleListing);
  const moduleListingDataBroker = useSelector(
    (state) => state.courses.moduleListingBroker
  );
  const [notesList, setNotesList] = useState([]);
  const [insertNoteRecord, setInsertNoteRecord] = useState(null);
  const [insertFavRecord, setInsertFavRecord] = useState(null);
  const [moduleData, setModuleData] = useState({});
  const [iframeId, setIframeId] = useState(null);
  const [selectedModulePos, setSelectedModulePos] = useState(null);
  const [isLoad, setIsLoad] = useState(true)
  const [isModuleChange, setIsModuleChange] = useState(false)
  const [reload, setReload] = useState(true);
  const [isAnimCompleted, setIsAnimCompleted] = useState(false);
  const [isPaid, setIsPaid] = useState(false)
  const [hasTeaser, setHasTeaser] = useState(false)
  const [isLoggedIn, setIsLoggedIn] = useState(localStorage.getItem(SessionKeys.API_TOKEN_BROKER) || localStorage.getItem(SessionKeys.API_TOKEN))
  const [showLPLearnMore, setShowLPLearnMore] = useState(false)
  const [purchasedInfo, setPurchasedInfo] = useState({})

  const search = window.location.search;
  const params = new URLSearchParams(search);
  // const source = params.get("source");
  // const cid = params.get("cid");
  // const via_lp = params.get('via_lp');
  // const lp_id = params.get('lp_id');
  // const via_cat = params.get('via_cat');
  // const cat_id = params.get('cat_id');
  // const level_id = params.get('level_id');
  // const is_level = params.get('is_level');
  // const from = params.get('from')
  // const lp_source = params.get("lp_source");

  const c = params.get("c");
  let decodedString = atob(c);
  let paramsReq = JSON.parse(decodedString);
  const source = paramsReq.source;
  const via_lp = paramsReq.via_lp;
  const lp_id = paramsReq.lp_id;
  const via_cat = paramsReq.via_cat;
  const cat_id = paramsReq.catId;
  const level_id = paramsReq.level_id;
  const is_level = paramsReq.is_level;
  const cid = paramsReq.cid;
  const from = paramsReq.from;
  const lp_source = paramsReq.lp_source;

  const authBroker = useSelector((state) => state.auth.authBroker);
  const moduleNotesUpdate = useSelector(
    (state) => state.courses.moduleNotesUpdate
  );
  const moduleProgress = useSelector((state) => state.courses.moduleProgress);
  const lpData = useSelector((state) => state.courses.lpData)
  const courseRelatedData = useSelector((state) => state.courses.courseRelated)
  const isPremiumUser = useSelector((state) => state.user.isPremiumUser);
  const checkContent = useSelector((state) => state.home.checkContent);
  const userBranding = useSelector(state => state.user.userBranding);
  const courseDetailEcom = useSelector(state => state.courses.courseDetailEcom);
  const rankStatusRes = useSelector((state) => state.courses.rankStatusRes);
  const userRole = useSelector((state) => state.user.role);

  // const moduleData = moduleListing?.payload

  const { courseId } = useParams();
  const { courseCode } = useParams();
  const [congModal, setCongModal] = useState(true);
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const moduleNoteData = useSelector(
    (state) => state.courses.moduleNotesGet.payload
  );
  const nextButton = useRef(null);
  const [isShowCongrat, setIsShowCongrat] = useState(false)
  const [isFree, setIsFree] = useState(true)
  const [isLPCompleted, setIsLPCompleted] = useState(false)
  const [singleLpData, setSingleLpData] = useState({})
  const [courseListingData, setCourseListingData] = useState([])
  const [showNextCourse, setShowNextCourse] = useState(false)
  const [isLastRecord, setIsLastRecord] = useState(true)
  // If free course - 1, paid course - 2, lp/oblp - 3
  const [fromSection, setFromSection] = useState(1)
  const [backgroundURL, setBackgroundURL] = useState('')

  const myLearningPathsData = useSelector(state => state.courses.myLearningPaths)
  const [learningPathData, setLearningPathData] = useState({});
  const [showShimmer, setShowShimmer] = useState(false);

  const [show, setShow] = useState(false);
  const [newRank, setNewRank] = useState('')
  const [isGuest, setIsGuest] = useState(false);
  useEffect(() => {
    if (!_.isEmpty(authBroker)) {
      if (authBroker.payload.user.role.includes('guest')) {
        setIsGuest(true);
      }
    }
  }, [authBroker])






  const toggleNavDesktop = () => {
    var bodyclass = document.querySelector("body");
    var btnEl = document.querySelector("#mySidenav");
    var main = document.querySelector(".main");
    var varmain = document.querySelector(".smart-bar");
    var togicon = document.querySelector(".opens-course-launch");
    var toogleicon = document.querySelector("#openbtnd .closetoogle");
    var footerslide = document.querySelector(".footersection");
    var smartBar = document.querySelector(".smart-bar");
    // console.log(btnClasslist)
    if (btnEl.classList.contains("open")) {
      //document.getElementById("openbtnd").innerHTML = "<span class='closetoogle'></span>";
      btnEl.classList.remove("open");
      toogleicon.classList.add("closeopen");
      if (varmain) {
        varmain.style.marginLeft = "26.25rem";
      }
      if (smartBar) {
        // smartBar.style.marginLeft = "26.25rem";
        smartBar.style.cssText = 'margin-left: 26.25rem;padding-left: 2rem';
      }
      main.style.marginLeft = "26.25rem";
      togicon.classList.add("closeopenbt");
      bodyclass.classList.remove("sidemenuopened");
      footerslide.style.marginLeft = "26.25rem";
    } else {
      //document.getElementById("openbtnd").innerHTML ="<span class='opentogglbar'></span>";
      btnEl.classList.add("open");
      toogleicon.classList.remove("closeopen");
      main.style.marginLeft = "0";
      if (varmain) {
        varmain.style.marginLeft = "0";
      }
      togicon.classList.remove("closeopenbt");
      bodyclass.classList.add("sidemenuopened");
      footerslide.style.marginLeft = "0";
      if (smartBar) {
        smartBar.style.cssText = 'margin-left: 0;padding-left: 0';

      }
    }
  };
  useEffect(() => {
    if (!isMobile && isLoggedIn) {
      // alert('logged')
      clickStreamUser("course_launch_page", {
        courseCode: courseCode,
        userId: auth.authBroker?.payload?.user.user_id,
      });
    } else {
      clickStreamUser("course_launch_page", {
        courseCode: courseCode,
        username: localStorage.getItem(SessionKeys.USERNAME),
      });

    }
    window.scrollTo(0, 0);
    //getSingleLPData();
    return (() => {
      getModuleListingClearBroker()
      getModuleListingClear()
      dispatch(getCourseDetailEcomClear())
    })
  }, [dispatch]);

  useEffect(() => {
    console.log('Branding Data', userBranding)
    if (isMobile && !_.isEmpty(userBranding)) {
      const branding = userBranding.payload.payload;
      if (!_.isEmpty(branding)) {
        applyTheme(branding)
      }
    }
  }, [isMobile, userBranding])

  useEffect(() => {
    // find the type of module
    // if type === scorm and source != broker, call the notes and fav api
    // else if source === broker and type != scorm, call the marProgress api
    if (moduleId && !_.isEmpty(authBroker)) {
      // console.log("getNotes 2");
      // console.log("TODO AFTER CHANGES");
      if ((source != "broker")) {
        dispatch(
          getModulenotesGet({
            module: "getNotes",
            postData: {
              mid: moduleId,
              uid: authBroker.payload.user.user_id,
              course_code: courseCode.split("?")[0],
            },
          })
        );
        dispatch(
          getModuleFavGet({
            module: "getModuleFavourites",
            // token: localStorage.getItem(SessionKeys.API_TOKEN),
            postData: {
              mid: moduleId,
              uid: authBroker.payload.user.user_id,
              course_code: courseCode.split("?")[0],
            },
          })
        );
      }
      if ((source === "broker") &&
        (!['mov', 'mp4', 'mkv', 'webm', 'm3u8', 'url', 'pdf'].includes(selectedModule?.rsp_scromdata[0]?.type))) {
        if (isLoggedIn) {
          markModuleProgressFunc(moduleId, selectedModule?.crs)
        }
      }
    }
  }, [moduleId, authBroker]);

  const markModuleProgressFunc = (mId, cId) => {

    let reqBody = {
      module_id: mId,
      token: isMobile ? localStorage.getItem(SessionKeys.API_TOKEN) : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
      course_id: cId,
    }
    // console.log('is_purchased course launch',courseDetailEcom?.payload?.data?.purchased_info.is_purchased);
    // if(courseDetailEcom?.payload?.data?.purchased_info.is_purchased) {
    //   reqBody.course_id = cId;
    // }

    if (from==="lp" || via_lp ==="true") {
      reqBody.lp_id = lp_id;
    }

    // alert(reqBody)

    dispatch(
      markModuleProgress({
        module: "markModuleProgress",
        postData: reqBody,
      })
    );
  }

  useEffect(() => {
    if (source === "xsel" || source === "ecom") {
      let user_id = ""
      if (!_.isEmpty(auth.authBroker)) {
        // setIsLoading(true);
        setModuleData({});

        // courseCode.split("?")[0]
        user_id = auth.authBroker.payload.user.user_id;
        // dispatch(checkContentAccess({
        //   module: 'checkContentAccess',
        //   postData: {
        //     token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
        //     origin: source === 'ecom' ? 'xsel' : 'broker',
        //     entity_id: source === 'ecom' ? courseCode.split("?")[0] : '',
        //     entity_type: 'courses'
        //   }
        // }))

      }
      // dispatch(
      //   getModuleListing({
      //     module: "getNIITAdminModule",
      //     postData: {
      //       user_id: user_id,
      //       course_id: courseCode.split('?')[0],
      //     },
      //   })
      // );


      let reqBody = {
        token: isMobile ? localStorage.getItem(SessionKeys.API_TOKEN) : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
        lp_id:lp_id,
        session_id: localStorage.getItem(SessionKeys.SESSION_ID),
        entity_id: cid
      };
      if(from==="lp" || via_lp ==="true"){
        reqBody.lp_id=lp_id;
      }else if(from==="bundle"){
        reqBody.bundle_id=lp_id;
      }

      dispatch(
        getCourseDetailEcom({
          URL: `${CONFIG.API_URL_BROKER}${API_LIST.ECOM_API.COURSE_DETAIL_ECOM}`,
          payload:reqBody ,
          method: "post",
          isJSON: true
        })
      )
    } else {
      // setIsLoading(true);
      setModuleData({});

      let payload = {
        module: "get_all_course_modules",
        token: isMobile ? localStorage.getItem(SessionKeys.API_TOKEN) : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
        courseId: courseCode.split('?')[0],
      };
      if(from==="lp" || via_lp ==="true"){
        payload.lpId=lp_id;
      }else if(from==="bundle"){
        payload.bundle_id=lp_id;
      }
      dispatch(
        getModuleListingBroker(payload)
      );
    }
  }, [authBroker])

  useEffect(() => {
    // console.log('CHECK CONTENT', checkContent)
    if (!_.isEmpty(checkContent)) {
      if (checkContent.status === "success") {
        const data = checkContent.payload.payload;
        if (!_.isEmpty(data)) {
          // setIsFree(data.is_free)
          if (via_lp === 'true' || from === "lp") {
            setFromSection(3)
          } else if (data.is_free) {
            setFromSection(1)
          } else {
            setFromSection(2)
          }
          // dispatch(checkContentAccessClear());
        }
      }
    }
  }, [checkContent]);

  useEffect(() => {
    if (source === "xsel" || source === "ecom") {
      if (
        !_.isEmpty(courseDetailEcom) &&
        courseDetailEcom.status === "success"
      ) {
        console.log('dataModules: ', courseDetailEcom.payload.data);
        if (courseDetailEcom?.payload) {
          const modulesInfo = _.cloneDeep(courseDetailEcom.payload.data);
          if (!_.isEmpty(modulesInfo.purchased_info)) {
            setPurchasedInfo(modulesInfo.purchased_info)
          } else {
            setPurchasedInfo({})
          }
          modulesInfo?.modules?.sort((a, b) => parseFloat(a.module_sequence) - parseFloat(b.module_sequence));
          if (modulesInfo.modules.length > 0) {
            modulesInfo.modules[0].isLock = false;
            for (let [index, modules] of modulesInfo.modules.entries()) {
              modules.isLock = modules.isLock === false ? modules.isLock : true;
              if (modules.progress > 0) {
                modules.isLock = false;
                if (index + 1 !== modulesInfo.modules.length)
                  modulesInfo.modules[index + 1].isLock =
                    _.toNumber(modules.progress) === 100 ? false : true;
              }
            }
          }
          setHasTeaser(modulesInfo.is_teaser)
          console.log("modulesInfo", modulesInfo);

          if (_.isArray(modulesInfo.resources_tab) && modulesInfo.resources_tab.length > 0) {
            for (let resource of modulesInfo.resources_tab) {
              if (resource.url.includes('.pdf')) {
                resource.url = CONFIG.API_URL_BROKER_ADMIN + "/pdfview/?path=" + btoa(resource.url) + "&u_token=" + localStorage.getItem(SessionKeys.API_TOKEN_BROKER)
              }
            }
          }
          setModuleData(modulesInfo);
          modulesInfo.modules.map((item, index) => {
            if (item.module_id === selectedModule?.module_id) {
              setSelectedModulePos(index);
              onClickModule(item, index)
            }
          });
        }
      }
    } else {
      if (
        !_.isEmpty(moduleListingDataBroker) &&
        moduleListingDataBroker.status === "success"
      ) {
        // console.log(moduleListingDataBroker.payload.payload);
        if (moduleListingDataBroker?.payload) {
          const modulesInfo = _.cloneDeep(moduleListingDataBroker.payload);
          modulesInfo?.modules?.sort((a, b) => parseFloat(a.module_sequence) - parseFloat(b.module_sequence));
          if (modulesInfo.modules.length > 0) {
            modulesInfo.modules[0].isLock = false;
            for (let [index, modules] of modulesInfo.modules.entries()) {
              modules.isLock = modules.isLock === false ? modules.isLock : true;
              if (modules.progress > 0) {
                modules.isLock = false;
                if (index + 1 !== modulesInfo.modules.length)
                  modulesInfo.modules[index + 1].isLock =
                    _.toNumber(modules.progress) === 100 ? false : true;
              }
            }
          }

          setIsPaid(false)
          setHasTeaser(false)
          if (_.isArray(modulesInfo.resources_tab) && modulesInfo.resources_tab.length > 0) {
            for (let resource of modulesInfo.resources_tab) {
              if (resource.url.includes('.pdf')) {
                resource.url = CONFIG.API_URL_BROKER_ADMIN + "/pdfview/?path=" + btoa(resource.url) + "&u_token=" + localStorage.getItem(SessionKeys.API_TOKEN_BROKER)
              }
            }
          }
          // console.log("modulesInfo", modulesInfo);
          setModuleData(modulesInfo);
          modulesInfo.modules.map((item, index) => {
            if (item.id === selectedModule?.module_id) {
              setSelectedModulePos(index);
            }
          });
        }

        // console.log("moduleData: ", moduleListingDataBroker);
      }
    }
  }, [courseDetailEcom, moduleListingDataBroker]);

  useEffect(() => {
    if (!_.isEmpty(moduleData) && !_.isEmpty(courseDetailEcom)) {
      if (courseDetailEcom.status === 'success') {
        const payload = courseDetailEcom.payload.data;
        console.log('courseDetailEcom', courseDetailEcom, payload)
        if (!_.isEmpty(payload) && !_.isEmpty(payload.purchased_info)) {
          const purchased_info = payload.purchased_info;
          console.log('courseDetailEcom', purchased_info)
          if(purchasedInfo&&!_.isEmpty(purchasedInfo)){
          setIsFree(!purchased_info.is_purchased )
          }else{
            setIsFree(true)
          }
          if (_.isEmpty(purchased_info) || purchased_info.is_purchased ||
            _.toNumber(purchased_info.selling_price) == 0) {
            setIsPaid(false)
          } else {
            setIsPaid(true)
          }
        }

      }
      dispatch(getCourseDetailEcomClear())
    }
  }, [moduleData, courseDetailEcom])

  useEffect(() => {

    if (!_.isEmpty(moduleData) && !_.isEmpty(moduleProgress)) {
      setIsLoading(false)
      if (
        source === "broker" &&
        moduleProgress?.status === "success"
      ) {
        // alert(JSON.stringify(moduleProgress))
        const selectModule = _.cloneDeep(selectedModule);
        // alert(JSON.stringify(selectModule))
        console.log('--------b')
        if (parseInt(selectModule.progress) !== 100) {
          if (['mov', 'mp4', 'mkv', 'webm', 'm3u8', 'url', 'pdf'].includes(selectModule?.rsp_scromdata[0]?.type)) {
            selectModule.progress = 100;
            setSelectedModule(selectModule);
          } else {
            setTimeout(() => {
              selectModule.progress = 100;
              setSelectedModule(selectModule);
            }, 8000)
          }

          if ((moduleData?.modules?.length === selectedModulePos + 1)) {
            if (['mov', 'mp4', 'mkv', 'webm', 'm3u8', 'url', 'pdf'].includes(selectModule?.rsp_scromdata[0]?.type)) {
              // if (_.toNumber(moduleData.learning_points) > 0) {
              setTimeout(() => {
                setIsShowCongrat(true)
              }, 2000)
              // }
            } else {
              // if (_.toNumber(moduleData.learning_points) > 0) {
              setTimeout(() => {
                setIsShowCongrat(true)
              }, 10000)
              // }
            }
          }

        }
        dispatch(markModuleProgressClear());

      }
    }
  }, [moduleProgress]);

  useEffect(() => {

    // console.log("selectedmodule", selectedModule);
    if (!_.isEmpty(moduleData)) {
      const moduleDataClone = _.cloneDeep(moduleData);
      // console.log("moduleDataAtProgress3: ", moduleData);
      for (let [index, module] of moduleDataClone.modules.entries()) {
        if (module.module_id === selectedModule?.module_id) {
          // if (moduleDataClone.modules[index].progress < 100)
          moduleDataClone.modules[index].progress = _.toNumber(
            selectedModule?.progress
          );
        }
        module.isLock = module.isLock === false ? module.isLock : true;
        if (module.progress > 0) {
          module.isLock = false;
          if (index + 1 !== moduleDataClone.modules.length)
            moduleDataClone.modules[index + 1].isLock =
              _.toNumber(module.progress) === 100 ? false : true;
        }
      }
      setModuleData(moduleDataClone);
    }
  }, [selectedModule]);

  useEffect(() => {

    const handleProgress = (evt) => {
      let dataObj =
        typeof evt.data === "object" ? evt.data : JSON.parse(evt?.data);
      if (dataObj && dataObj?.method === "progress") {
        const selectModule = _.cloneDeep(selectedModule);

        console.log('-----moduleDataAtProgress: ', dataObj, selectModule)
        if (parseInt(selectModule.progress) !== 100 && dataObj.module_id === selectModule.module_id) {
          if (source !== 'broker' || parseInt(dataObj.value) !== 100) {
            selectModule.progress = parseInt(dataObj.value);
          }
          console.log('moduleDataAtProgress1: ', dataObj, selectModule)
          if (source !== 'broker' && parseInt(dataObj.value) === 100 && (moduleData?.modules?.length === (selectedModulePos + 1))) {
            // console.log('moduleDataAtProgress1: ',moduleData)
            // if (_.toNumber(moduleData.learning_points) > 0) {
            setIsShowCongrat(true)
            // }
            setTimeout(() => {
              window.scrollTo(0, document.body.scrollHeight);
            }, 1500)

          }
          // alert(source)
          if (parseInt(dataObj.value) === 100 && source === 'broker') {
            // if (parseInt(dataObj.value) > 0 && source === 'broker') {
            // alert(dataObj.value)
            if (isLoggedIn) {
              // alert('isloggedin')
              markModuleProgressFunc(selectModule.module_id, selectedModule?.crs);
            }
          }
          console.log('--------h')
          setSelectedModule(selectModule);

        }


      }
    };
    // if (source !== "broker") {
    window.addEventListener("message", handleProgress);
    return () => {
      window.removeEventListener("message", handleProgress);
    };
    // }
  }, [selectedModule]);


  useEffect(() => {
    let activeTabName = null;
    switch (activeTab) {
      case 1:
        activeTabName = "Modules";
        break;
      case 2:
        activeTabName = "Resources/Toolkits";
        break;
      case 3:
        activeTabName = "My Favorites";
        break;
      case 4:
        activeTabName = "Notes";
        break;
    }
    clickStreamUser("course_tab_change", {
      courseCode: courseCode,
      activeTab: activeTabName,
    });
  }, [activeTab]);

  useEffect(() => {
    if (!_.isEmpty(lpData)) {
      if (lpData.status === 'success') {
        let learning = _.cloneDeep(lpData.payload.payload)
        if (!_.isEmpty(learning)) {
          let sendFlag = false;
          let pushCourse = false;
          let anyLockExists = false;
          let courseToPush = []
          learning = formatLPCoursesList(learning)
          if (learning.coursesList) {
            for (let [index, course] of learning.coursesList.entries()) {
              console.log(`I am ${course.name} - ${courseCode} - ${course.crscd}`)
              let currentCourse = course;
              let nextCourse = learning.coursesList[index + 1];
              if (!currentCourse?.is_checklist_approved && currentCourse?.is_checklist_present && !sendFlag) {
                if (currentCourse.crs_progress >= 100 && !currentCourse.isLock
                  && (index !== learning.coursesList.length - 1)) {
                  dispatch(
                    getCheckListInsert({
                      module: 'checklist-insert',
                      postData: {
                        token: isMobile ? localStorage.getItem(SessionKeys.API_TOKEN) : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
                        lp_id: learning?.id,
                        entity_id: currentCourse.source === 'broker' ? currentCourse.id : currentCourse?.crscd,
                        entity_type: !currentCourse?.is_level ? currentCourse.entity_type : "level"
                      }
                    }))
                  sendFlag = true;
                }
              }

              // if (is_level === 'true') {
              //   if (_.toNumber(course.id) === _.toNumber(level_id)) {
              //     pushCourse = true;
              //   }
              // } else {
              //   if (course.crscd === courseCode.split("?")[0]) {
              //     pushCourse = true;
              //   }
              // }
              if (anyLockExists) {
                if (is_level === 'true') {
                  if (course.id === level_id) {
                    if (course.crs_progress < 100) {
                      learning.newCourseList.push(course)
                    }
                    pushCourse = true;
                    // learning.newCourseList.push(course)
                    // if (course.crs_progress !== 100) {
                    // }
                  } else if (pushCourse) {
                    learning.newCourseList.push(course)
                  } else {
                    if (course.crs_progress < 100) {
                      // learning.newCourseList.push(course)
                      courseToPush.push(course)
                    }
                  }
                } else {
                  if (course.crscd === courseCode.split("?")[0]) {
                    console.log('this is me ' + course.name)
                    pushCourse = true;
                    // learning.newCourseList.push(course)
                    // if (course.crs_progress !== 100) {
                    // }
                  } else if (pushCourse) {
                    learning.newCourseList.push(course)
                  } else {
                    if (course.crs_progress < 100) {
                      // learning.newCourseList.push(course)
                      courseToPush.push(course)
                    }
                  }
                }
              } else {
                if (course.crs_progress < 100) {
                  // learning.newCourseList.push(course)
                  courseToPush.push(course)
                }
              }
            }
            for (let course of courseToPush) {
              learning.newCourseList.push(course)
            }
            learning.coursesList = learning.newCourseList;
          }
          if (learning.coursesList.length === 0) {
            console.log('is Last Record')
            setIsLastRecord(true)
            setShowNextCourse(false)
          } else {
            console.log('show Next Course')
            // TODO: FOR TESTING
            // setIsLastRecord(false)
            // setShowNextCourse(true)
          }
          console.log('LP DATA', learning, courseCode.split("?")[0])
          setSingleLpData(learning)
        }
      } else {
        setSingleLpData({})
      }
      dispatch(getSingleLPClear())
    }
    // return (() => {
    //   setShowNextCourse(false)
    //   setIsLastRecord(true)
    // })
  }, [lpData])

  useEffect(() => {
    if (!_.isEmpty(courseRelatedData)) {
      if (courseRelatedData.status === 'success') {
        if (!_.isEmpty(courseRelatedData.payload.payload)) {
          let courseListing = _.cloneDeep(courseRelatedData.payload.payload);

          if (_.isArray(courseListing)) {
            let formattedList = [];
            for (let course of courseListing) {
              formattedList.push(getFormatCourseListFromWoo(course, isPremiumUser));
            }
            let newFormattedList = [];
            for (let course of formattedList) {
              let pushNextCourse = true;

              // let coursesData = formatWooCourses(data)
              course.isLock = false;

              if (course.source === 'broker') {
                course.is_paid = true;
                if (course.durationUnit === "Hours") {
                  course.duration = convertHoursToMins(course.duration);
                }
                course.duration = convertTimeFormat(_.toNumber(course.duration));
                course.durationUnit = "";
              }
              if (course.crscd === courseCode.split("?")[0]) {
                pushNextCourse = false;
              }
              if (pushNextCourse) {
                newFormattedList.push(course)
              }
            }
            if (!_.isEmpty(newFormattedList)) {
              // TODO: FOR TESTING
              debugger
              // setShowNextCourse(true)
              // setIsLastRecord(false)
            }
            console.log('FORMAT LISTING', newFormattedList)
            setCourseListingData(newFormattedList)
          }
        }
      } else {
        setCourseListingData([])
      }
      dispatch(getCourseRelatedClear())
    }
    // return (() => {
    //   setShowNextCourse(false)
    //   setIsLastRecord(true)
    // })
  }, [courseRelatedData])

  useEffect(() => {
    if (!_.isEmpty(rankStatusRes)) {
      if (rankStatusRes?.status === "success") {
        let data = rankStatusRes?.payload?.payload;
        if (data.rank_increase) {
          setNewRank(data.rank)
          localStorage.setItem(SessionKeys.CURRENT_RANK, data.rank)
          setShow(true)
          dispatch(getRankStatusClear({}))
        } else {
          setShow(false)
        }
      }
    }
  }, [rankStatusRes])

  useEffect(() => {
    if (isShowCongrat) {
      setTimeout(() => {
        if (via_lp === 'true' || from === "lp") {
          getSingleLPData()
        } else if (via_cat === 'true') {
          getCoursesListingData()
        }
      }, 2000);
    }
    if (isAnimCompleted) {
      if (userRole !== "manager" && !isGuest) {
        checkRankStatusFunc(dispatch, getRankStatus)
      }
      return (() => {
        setIsAnimCompleted(false);
      })
    }
  }, [isShowCongrat, isAnimCompleted])

  const onClickModule = (m, idx) => {
    // console.log("moduleData", m);


    setModuleId(m.module_id);
    setSelectedModulePos(idx);
    console.log('--------idx')
    setSelectedModule(m);
    if (selectedModule?.module_id === m.module_id) {
      // setReload(false)
      // setTimeout(() => {
      //   setIsLoad(false)
      //   setReload(true)
      // }, 3000)
    } else {
      setIsModuleChange(true)


      setCourseTitle(m.title);

      setIsModuleChange(false)
      setReload(true)
      setIsLoad(true)
    }
    if (!isMobile) {
      clickStreamUser("course_module_click", {
        courseCode: courseCode,
        moduleId: m.module_id,
        moduleName: m.title,
        userId: auth.authBroker?.payload?.user.user_id,
      });
    } else {
      clickStreamUser("course_module_click", {
        courseCode: courseCode,
        moduleId: m.module_id,
        moduleName: m.title,
        username: localStorage.getItem(SessionKeys.USER_NAME),
      });
    }
  };
  const gotoHome = () => {
    navigate(-1)
    return;
  };

  const generateZIP = () => {
    // window.captureMyEvents(
    //   "jbcToolKitCourseLevel",
    //   {
    //     ttl: moduleList.title,
    //   }
    // )
    const links = [];
    setLoader(true);
    moduleData?.modules?.forEach((module) => {
      module.rsp_toolkit.forEach((m) => {
        links.push(m.url);
      });
    });
    var zip = new JSZip();
    var count = 0;
    var zipFilename = `${moduleData.courseName}.zip`;
    // var zipFilename = "a.zip"

    links.forEach(function (url, i) {
      var filename = links[i];
      filename = filename
        .replace(/[\/\*\|\:\<\>\?\"\\]/gi, "")
        .replace(CONFIG.API_URL, "");
      // loading a file and add it in a zip file
      JSZipUtils.getBinaryContent(url, function (err, data) {
        if (err) {
          setLoader(false);
          throw err; // or handle the error
        }
        zip.file(filename, data, { binary: true });
        count++;
        if (count === links.length) {
          zip.generateAsync({ type: "blob" }).then(function (content) {
            saveAs(content, zipFilename);
            setLoader(false);
          });
        }
      });
    });
  };

  const nextModule = () => {
    for (let [index, module] of moduleData.modules.entries()) {
      if (module.module_id === selectedModule?.module_id) {
        onClickModule(moduleData.modules[index + 1], index + 1);
      }
    }
    window.scrollTo(0, 0);
  };

  const openHamburgerMenu = (data) => {
    dispatch(openHamburger(true));
    if (data.sectionId) {
      const positionTop = document.getElementById("courseTitle").offsetTop;
      // console.log(positionTop);
      // window.scrollY(positionTop);
    }
  };

  const fetchDataFromIframe = (data) => {
    // console.log(data);
    setActiveTab(4);
    setInsertNoteRecord(data);
    openHamburgerMenu(data);
  };

  const openFavourites = (data) => {
    // console.log(data);
    setActiveTab(3);
    setInsertFavRecord(data);
    openHamburgerMenu(data);
  };

  const handlePostMessage = (sid, methodName = "bookmark") => {
    // console.log("sid, methodName", sid, methodName);
    if (iframeRef && iframeRef.current) {
      // console.log("iframe ref present");
      let payload = { method: methodName, section: sid };
      // console.log("payload", payload);
      iframeRef.current.contentWindow.postMessage(JSON.stringify(payload), "*");
    }
  };
  useEffect(() => {
    // dispatch(getModuleNotesUpdate())
  }, [moduleNotesUpdate]);

  useEffect(() => {
    // console.log("update", moduleNotesUpdate);
    if (!_.isEmpty(moduleNotesUpdate)) {
      // console.log("updated", moduleNotesUpdate.payload.status);
      if (moduleNotesUpdate.payload.status === true) {
        // console.log("getNotes 3");
        // TODO: TO CHANGE AFTER MAKING USER ID CHANGES
        // dispatch(getModulenotesGet({
        //   module: 'getNotes',
        //   // token: localStorage.getItem(SessionKeys.API_TOKEN),
        //   postData: { mid: moduleId, uid:user_id, course_code:courseCode }
        // }))
        dispatch(getModuleNotesUpdateClear());
      }
    }
  }, [moduleNotesUpdate]);

  // useEffect(() => {
  //     console.log('update', moduleNotesUpdate)
  //     if (!_.isEmpty(moduleNotesUpdate)) {
  // console.log('updated', moduleNotesUpdate.payload.status)
  // if (moduleNotesUpdate.payload.status === true) {
  //     console.log('getNotes 3')
  // TODO: AFTER CHANGE TO USER ID
  //     dispatch(getModulenotesGet({
  //         module: 'getNotes',
  //         postData: { mid: moduleId, uid:user_id, course_code:courseCode }
  //     }))
  //     dispatch(getModuleNotesUpdateClear())
  // }
  //     }
  // }, [moduleNotesUpdate])

  const sortResources = (arr) => {
    // console.log("ModuleDataa sort resources",arr)
    var array1 = [];
    var array2 = [];
    var glossary = null;
    var coursehelp = null;
    arr?.map((item) => {
      if (item?.title.toLowerCase() === "glossary") {
        glossary = item;
      } else if (item?.title.toLowerCase() === "course help") {
        coursehelp = item;
      } else array1.push(item);
      // if (item.title.toLowerCase() === 'pdf') {
      //     array2 = item.sort(function (a, b) {
      //         return a.localeCompare(b)
      //     })
      //     return array2
      // } else array2.push(item)
    });
    if (glossary != null) {
      array1.push(glossary);
    }
    if (coursehelp != null) {
      array1.push(coursehelp);
    }
    return array1;
  };

  const sortByAlphabetical = (list) => {
    return list
    // if (list.title)


    // return list.sort((a, b) => a.title.localeCompare(b.title));
  };

  // console.log("Index===>", selectedModulePos + 1)
  // console.log("module length", moduleData?.modules?.length)
  // console.log("module progress", parseInt(selectedModule?.progress))
  const [scroll, setScroll] = useState(false)
  useEffect(() => {
    window.addEventListener("scroll", () => {
      setScroll(window.scrollY > 10)
    })
  }, [])

  const getSingleLPData = () => {

    setShowShimmer(true)
    if (lp_source === "xsel" || source === "ecom") {
      dispatch(getMyLearningPaths({
        module: 'getMyLearningPathsEcom',
        postData: {
          token: isMobile ? localStorage.getItem(SessionKeys.API_TOKEN) : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          is_onboarding: 0,
          id: lp_id,
        }
      }))
    } else {
      dispatch(getMyLearningPaths({
        module: 'getMyLearningPaths',
        postData: {
          token: isMobile ? localStorage.getItem(SessionKeys.API_TOKEN) : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          assigned: 0,
          lp_id: lp_id,
        }
      }))
    }

    // dispatch(getSingleLP({
    //   module: 'singleLPInfo',
    //   postData: {
    //     token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
    //     lp_id: lp_id
    //   }
    // }))
  }

  useEffect(() => {
    // console.log('LearningPath', myLearningPathsData)
    if (!_.isEmpty(myLearningPathsData)) {
      if (myLearningPathsData.status === 'success') {
        setIsLoading(false);
        setShowShimmer(false)
        if (!_.isEmpty(myLearningPathsData.payload.payload)) {
          let learning = _.cloneDeep(myLearningPathsData.payload.payload)
          let learningData = getFormatedDataOfLPUtils(learning, dispatch,moduleData.courseName)

          let contentArr = [];
          let learningTemp = _.cloneDeep(learningData);
          for (const record of learningData?.coursesList) {
            if (record.crs_progress < 100 && record.name!==moduleData.courseName) {
              if(learningTemp?.survey_optional && record?.entity_type === 'survey'){
                continue;
              }
              contentArr.push(record)
            }
          }


          for (const record of contentArr) {
              let checklistArray = [];
              record.clInfo = {};
              if (
                record.is_checklist_present &&
                !_.isEmpty(record.checklist_data) &&
                !_.isEmpty(record.checklist_data.checklist_title)
              ) {
                // alert(JSON.stringify(record.checklist_data.checklist_title))
                checklistArray = record.checklist_data.checklist_title;
                let clData = record.checklist_data;
                record.clInfo = {
                  lp_name: clData.prgm_nm,
                  course_or_level: clData.type,
                  course_name: clData.crs,
                  course_completion_date: clData.course_completion_date
                    ? clData.course_completion_date
                    : "",
                  rea_name: clData.user_name,
                  title_array: checklistArray,
                };
                // if (learning.id == 16548) alert(JSON.stringify(record))
              }
          }




          learningTemp.coursesList = contentArr;


          if (learningTemp.coursesList.length === 0) {
            console.log('is Last Record')
            setIsLastRecord(true)
            setShowNextCourse(false)
            setShowLPLearnMore(false)
            setIsLPCompleted(true)
          } else {
            console.log('show Next Course')
            // TODO: TESTING
            debugger
            setIsLastRecord(false)
            setShowNextCourse(true)
            setShowLPLearnMore(true)
            setIsLPCompleted(false)
          }
          setLearningPathData(learningTemp)
        }
      }
      dispatch(getMyLearningPathsClear())
    }
  }, [myLearningPathsData])

  const getCoursesListingData = () => {
    dispatch(getCourseRelated({
      module: 'courseRelated',
      postData: {
        token: isMobile ? localStorage.getItem(SessionKeys.API_TOKEN) : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
        brokerage_id: localStorage.getItem(SessionKeys.BROKER_ID),
        category_id: cat_id
      }
    }))
  }

  return (
    <>
      <Loader start={isLoading} msg={loaderMsg} />
      <div className={scroll ? "main scrollnavmob" : "main"} style={{ marginLeft: "26.25rem" }}>
        <div id="moduleTitle" className="video_img course-launch-page" aria-hidden="true">
          <div className="container">
            <div id="mySidenav" className="sidenav" style={{ marginTop: "17px" }}>
              {location.pathname.includes("/courseDetail") ||
                !showAllMenu ? (
                <div className="opens-course-launch">
                  <button
                    className="openbtn"
                    id="openbtnd"
                    ref={hamburgerMenu}
                    onClick={() => {
                      toggleNavDesktop();
                    }}
                  >
                    <span id="forHandleBurgerMenu" className="closetoogle closeopen"></span>
                  </button>
                </div>
              ) : (
                ""
              )}
              <ul
                className="nav nav-tabs"
                id="myTab"
                role="tablist"
                style={{ marginBottom: "18px" }}
              >
                <li className="nav-item intro_navitem" role="presentation">
                  <button
                    className={"nav-link " + (activeTab === 1 ? "active" : "")}
                    id="modules-tab"
                    onClick={() => {
                      setActiveTab(1);
                    }}
                  >
                    Modules
                  </button>
                </li>
                { <li className="nav-item intro_navitem" role="presentation">
                  <button
                    className={"nav-link  " + (activeTab === 2 ? "active" : "")}
                    id="modules-tab"
                    onClick={() => {
                      setActiveTab(2);
                    }}
                  >
                    Resources
                  </button>
                </li>}
                <li className="nav-item intro_navitem" role="presentation">
                  {source === "xsel" || source === "woo" || source === "ecom" ? (
                    <button
                      className={"nav-link " + (activeTab === 3 ? "active" : "")}
                      id="modules-tab"
                      onClick={() => {
                        setActiveTab(3);
                      }}
                    >
                      Favorites
                    </button>
                  ) : (
                    ""
                  )}
                </li>
                <li className="nav-item intro_navitem" role="presentation">
                  {source === "xsel" || source === "woo" || source === "ecom" ? (
                    <button
                      className={"nav-link " + (activeTab === 4 ? "active" : "")}
                      id="modules-tab"
                      onClick={() => {
                        setActiveTab(4);
                      }}
                    >
                      Notes
                    </button>
                  ) : (
                    ""
                  )}
                </li>
              </ul>
              <div className="tab-content" id="myTabContent">
                {activeTab === 1 ? (
                  <div
                    className={" "}
                    id="modules"
                    role="tabpanel"
                    aria-labelledby="modules-tab"
                  >
                    {/* <h4 onClick={gotoHome}>Home</h4> */}
                    <div className="modules-menu">
                      <div
                        className="modules-menu-item d-flex "

                      >
                        <div className="left-arrow cursor-pointer button-reset course-home-btn"
                          onClick={() => gotoHome()}>
                          <button className="button-reset">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="45"
                              height="45"
                              viewBox="0 0 30 30"
                            >
                              <defs>
                                <linearGradient
                                  id="linear-gradient"
                                  x2="1"
                                  y1="0.5"
                                  y2="0.5"
                                  gradientUnits="objectBoundingBox"
                                >
                                  <stop offset="0" stopColor="#6941C6"></stop>
                                  <stop offset="1" stopColor="#ed156e"></stop>
                                </linearGradient>
                              </defs>
                              <circle
                                cx="15"
                                cy="15"
                                r="15"
                                fill="url(#linear-gradient)"
                                data-name="Ellipse 57"
                                strokeWidth="1"
                              ></circle>
                              <circle
                                cx="13"
                                cy="13"
                                r="13"
                                fill="#fff"
                                data-name="Ellipse 179"
                                transform="translate(2 2)"
                              ></circle>
                              <g
                                id="colored-arrow"
                                fill="none"
                                stroke="#6941C6"
                                strokeLinecap="round"
                                strokeWidth="1"
                                data-name="Group 2517"
                                transform="rotate(-90 42.776 229.302)"
                              >
                                <g
                                  data-name="Group 2452"
                                  transform="translate(251 196.001)"
                                >
                                  <g
                                    data-name="Group 2450"
                                    transform="rotate(135 3.039 1.259)"
                                  >
                                    <path
                                      d="M8.594 0L0 0"
                                      data-name="Line 51"
                                    ></path>
                                    <path
                                      d="M8.594 0L0 0"
                                      data-name="Line 275"
                                    ></path>
                                  </g>
                                  <g
                                    data-name="Group 2451"
                                    transform="rotate(45 3.039 7.337)"
                                  >
                                    <path
                                      d="M8.594 0L0 0.001"
                                      data-name="Line 51"
                                    ></path>
                                    <path
                                      d="M8.594 0L0 0.001"
                                      data-name="Line 275"
                                    ></path>
                                  </g>
                                </g>
                                <g
                                  data-name="Group 2516"
                                  transform="rotate(-90 232 -24.948)"
                                >
                                  <path
                                    d="M9.483 0L0 0"
                                    data-name="Line 51"
                                  ></path>
                                  <path
                                    d="M9.483 0L0 0"
                                    data-name="Line 275"
                                  ></path>
                                </g>
                              </g>
                            </svg>
                          </button>
                          {/* <img src="/images/left_arrow.png" /> */}
                        </div>
                        <span
                          className="title sidenav_home"
                          style={{
                            cursor: "pointer",
                          }}
                          onClick={() => gotoHome()}
                          dangerouslySetInnerHTML={{
                            __html: moduleData?.courseName,
                          }}
                        >

                        </span>
                      </div>
                      {moduleData &&
                        moduleData?.modules &&
                        moduleData?.modules?.map((module, index) => {
                          return (
                            <div
                              className={`tab-content cursor pointer`}
                              id="myTabContent"

                              key={index}
                            >
                              {/* <div className="tab-content cursor-pointer" id="myTabContent"
                                                    onClick={() => { onClickModule(module, index) }}> */}
                              <div
                                className="modules-menu-item d-flex moduleIcon cursor pointer"
                                style={{ padding: "8px" }}
                              >
                                <div className="box">
                                  {
                                    (isPaid && hasTeaser && index != 0) ?
                                      <div style={{ width: 45, height: 45 }}>
                                        <span class="lock-bar lock-bar"></span>
                                      </div>
                                      :
                                      <div
                                        style={{ width: 45, height: 45 }}
                                        className="chart-01"
                                      >
                                        <CircularProgressbar
                                          value={module.progress}
                                          styles={buildStyles({
                                            pathColor:
                                              parseInt(module.progress) < 100
                                                ? `#FF9700`
                                                : "#00B70E",
                                            trailColor: "#EBEBEB",
                                          })}
                                        />
                                      </div>
                                  }
                                </div>
                                <span
                                  className={`module-title-xsel ${module.isLock
                                    ? "cursor-not-allowed"
                                    : "cursor-pointer"
                                    }`}
                                >
                                  <span
                                    className={`title sidenav_title 
                                    ${module.module_id ===
                                        selectedModule?.module_id
                                        ? "active"
                                        : ""
                                      }
                                    `}
                                    onClick={() => {
                                      if (isPaid && hasTeaser) {

                                      } else if (!module.isLock) {
                                        onClickModule(module, index);
                                      }
                                    }}
                                  >
                                    {module.title}
                                    {/* {module.isLock ? <span className="lear_icon"><img src="/images/Locked.svg" alt="lock" /></span> : "cursor pointer"}                                                             */}
                                  </span>
                                </span>
                              </div>

                              <span className="title"></span>
                            </div>
                          );
                        })}
                    </div>
                  </div>
                ) : (
                  ""
                )}
                {activeTab === 2 ? (
                  <div
                    className=" "
                    id="resources"
                    role="tabpanel"
                    aria-labelledby="resources-tab"
                  >
                    <div
                      className="resources-item"
                      style={{ marginLeft: "21px" }}
                    >
                      {/* <h5 style={{ color: "black", padding:"0px 35px"}}>Resources section</h5> */}

                      <div className="modules-menu mb-3">
                        {/* <div className="row course-text">
                                                <span className="col-lg-10 course">Course</span>
                                                <span className="col-lg-2 p-0" >
                                                    <a className="bg" onClick={generateZIP}>
                                                        <img
                                                            className="image_on"
                                                            src="/images/note_icon.png"
                                                            alt="logo"
                                                        />
                                                    </a>
                                                </span>
                                            </div> */}
                        {isPaid ?
                          <div className="restricted-access text-center mb-3">
                            <div className="lock-icon">
                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="64" height="64" fill="#292D32">
                                <path
                                  d="M19 10H20C20.5523 10 21 10.4477 21 11V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V11C3 10.4477 3.44772 10 4 10H5V9C5 5.13401 8.13401 2 12 2C15.866 2 19 5.13401 19 9V10ZM5 12V20H19V12H5ZM11 14H13V18H11V14ZM17 10V9C17 6.23858 14.7614 4 12 4C9.23858 4 7 6.23858 7 9V10H17Z">
                                </path>
                              </svg>
                            </div>
                              <p className="title">Access to Resources is restricted.</p>
                              <p className="message">
                                Please purchase this course to unlock all materials.
                              </p>
                         </div>
                          :moduleData &&
                          _.isArray(moduleData?.resources_tab) &&
                          moduleData.resources_tab.length > 0 ? (
                          sortResources(
                            sortByAlphabetical(moduleData?.resources_tab)
                          ).map((module, i) => {
                            return (
                              <ul
                                className="module-list"
                                style={{ paddingLeft: "0px" }}
                              >
                                <div className="module mt-0" key={i}>
                                  <>
                                    <div className="module-item-container row">
                                      <span className="col-lg-10 col-10">
                                        {/* {i + 1}. &nbsp; */}
                                        {module.title}
                                      </span>
                                      <span className="col-lg-2 col-2 p-2 d-flex align-items-end">
                                        <a
                                          href={module.url}
                                          className="download-link"
                                          download={false}
                                          target="_blank"
                                          rel="noreferrer"
                                        >
                                          <span>
                                            {module.type === "pdf" ? (
                                              <a className="bg">
                                                <button className="button-reset cursor-pointer">
                                                  <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="30"
                                                    height="30"
                                                    viewBox="0 0 30 30"
                                                  >
                                                    <defs>
                                                      <linearGradient
                                                        id="linear-gradient"
                                                        x2="1"
                                                        y1="0.5"
                                                        y2="0.5"
                                                        gradientUnits="objectBoundingBox"
                                                      >
                                                        <stop
                                                          offset="0"
                                                          stopColor="#6941C6"
                                                        ></stop>
                                                        <stop
                                                          offset="1"
                                                          stopColor="#ed156e"
                                                        ></stop>
                                                      </linearGradient>
                                                    </defs>
                                                    <circle
                                                      cx="15"
                                                      cy="15"
                                                      r="15"
                                                      fill="url(#linear-gradient)"
                                                      data-name="Ellipse 180"
                                                    ></circle>
                                                    <circle
                                                      cx="13"
                                                      cy="13"
                                                      r="13"
                                                      fill="#fff"
                                                      data-name="Ellipse 181"
                                                      transform="translate(2 2)"
                                                    ></circle>
                                                    <path
                                                      fill="#6941C6"
                                                      d="M5.684 8a3.015 3.015 0 01-.062-1.466c.262.003.237 1.157.062 1.466zm-.053 1.478a14.42 14.42 0 01-.887 1.959 11.507 11.507 0 011.966-.684 4.048 4.048 0 01-1.079-1.275zm-2.941 3.9c0 .025.412-.169 1.091-1.256a4.319 4.319 0 00-1.09 1.256zM7.75 5H12v10.25a.748.748 0 01-.75.75H.75a.748.748 0 01-.75-.75V.75A.748.748 0 01.75 0H7v4.25a.752.752 0 00.75.75zm-.25 5.369a3.136 3.136 0 01-1.334-1.681 4.492 4.492 0 00.194-2.006.783.783 0 00-1.494-.213 5.2 5.2 0 00.253 2.406 29.344 29.344 0 01-1.275 2.681h-.006c-.847.434-2.3 1.391-1.7 2.125a.971.971 0 00.668.319c.559 0 1.116-.562 1.909-1.931a17.813 17.813 0 012.469-.725 4.736 4.736 0 002 .609.809.809 0 00.616-1.359c-.434-.425-1.7-.3-2.3-.225zm4.281-7.087L8.719.219A.749.749 0 008.188 0H8v4h4v-.191a.748.748 0 00-.219-.528zm-2.315 7.977c.128-.084-.078-.372-1.338-.281 1.16.494 1.338.281 1.338.281z"
                                                      data-name="Icon awesome-file-pdf"
                                                      transform="translate(9 7)"
                                                    ></path>
                                                  </svg>
                                                </button>
                                              </a>
                                            ) : module.type?.toLowerCase() === "links" ?
                                              <a className="bg">
                                                <button className="button-reset cursor-pointer">
                                                  <svg width="30" height="30" className="links-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 1000" fill-rule="evenodd" clip-rule="evenodd">
                                                    <defs>
                                                      <linearGradient
                                                        id="linear-gradient"
                                                        x2="1"
                                                        y1="0.5"
                                                        y2="0.5"
                                                        gradientUnits="objectBoundingBox"
                                                      >
                                                        <stop
                                                          offset="0"
                                                          stopColor="#6941C6"
                                                        ></stop>
                                                        <stop
                                                          offset="1"
                                                          stopColor="#ed156e"
                                                        ></stop>
                                                      </linearGradient>
                                                    </defs>
                                                    <g>
                                                      <path d="M500,10C229.4,10,10,229.4,10,500s219.4,490,490,490s490-219.4,490-490S770.6,10,500,10L500,10L500,10z M435.8,741.7c-49,48.9-128.6,48.9-177.6,0c-49-49-49-128.6,0-177.5L384,438.4c49-48.9,128.6-48.9,177.6,0c1.3,1.3,2.6,2.6,3.8,4c0.8,0.7,1.4,1.2,2.2,2c2,2,3.6,4.2,4.9,6.5c0.1,0.2,0.3,0.4,0.4,0.7l-0.1,0.1c6,11.4,4.3,25.8-5.4,35.3c-9.6,9.6-24.2,11.4-35.5,5.1c-0.8,0.9-8.6-7-12.9-11.2l0,0c-25.6-25.6-66.8-25.8-92.4-0.2L300.7,606.6c-25.6,25.6-25.6,67,0,92.5l0,0c25.6,25.6,67,25.6,92.5,0l75.8-75.8c26.4,12.9,57.3,13.3,83.9,1.1L435.8,741.7L435.8,741.7L435.8,741.7z M741.7,435.8L615.9,561.6c-49,49-128.6,49-177.6,0c-1.3-1.3-2.6-2.6-3.8-4c-0.8-0.7-1.4-1.2-2.1-2c-2-2-3.6-4.2-4.9-6.5c-0.1-0.2-0.3-0.4-0.4-0.7l0.1-0.1c-6-11.4-4.3-25.8,5.4-35.3c9.6-9.6,24.2-11.4,35.5-5.1c0.8-0.9,8.6,7,12.9,11.2l0,0c25.6,25.6,66.8,25.8,92.4,0.2l126-126c25.6-25.6,25.6-67,0-92.5l0,0c-25.6-25.6-67-25.6-92.5,0l-75.8,75.8c-26.3-12.8-57.3-13.3-83.9-1.1l117-117.1c49-49,128.6-49,177.6,0C790.7,307.3,790.7,386.9,741.7,435.8L741.7,435.8L741.7,435.8z" fill="url(#linear-gradient)" />
                                                    </g>
                                                  </svg>
                                                </button>
                                              </a>
                                              : module.type === "doc" ? (
                                                <button className="button-reset">
                                                  <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="30"
                                                    height="30"
                                                    viewBox="0 0 30 30"
                                                  >
                                                    <defs>
                                                      <linearGradient
                                                        id="linear-gradient"
                                                        x2="1"
                                                        y1="0.5"
                                                        y2="0.5"
                                                        gradientUnits="objectBoundingBox"
                                                      >
                                                        <stop
                                                          offset="0"
                                                          stopColor="#6941C6"
                                                        ></stop>
                                                        <stop
                                                          offset="1"
                                                          stopColor="#ed156e"
                                                        ></stop>
                                                      </linearGradient>
                                                    </defs>
                                                    <circle
                                                      cx="15"
                                                      cy="15"
                                                      r="15"
                                                      fill="url(#linear-gradient)"
                                                      data-name="Ellipse 180"
                                                    ></circle>
                                                    <circle
                                                      cx="13"
                                                      cy="13"
                                                      r="13"
                                                      fill="#fff"
                                                      data-name="Ellipse 181"
                                                      transform="translate(2 2)"
                                                    ></circle>
                                                    <path
                                                      fill="#6941C6"
                                                      d="M5.684 8a3.015 3.015 0 01-.062-1.466c.262.003.237 1.157.062 1.466zm-.053 1.478a14.42 14.42 0 01-.887 1.959 11.507 11.507 0 011.966-.684 4.048 4.048 0 01-1.079-1.275zm-2.941 3.9c0 .025.412-.169 1.091-1.256a4.319 4.319 0 00-1.09 1.256zM7.75 5H12v10.25a.748.748 0 01-.75.75H.75a.748.748 0 01-.75-.75V.75A.748.748 0 01.75 0H7v4.25a.752.752 0 00.75.75zm-.25 5.369a3.136 3.136 0 01-1.334-1.681 4.492 4.492 0 00.194-2.006.783.783 0 00-1.494-.213 5.2 5.2 0 00.253 2.406 29.344 29.344 0 01-1.275 2.681h-.006c-.847.434-2.3 1.391-1.7 2.125a.971.971 0 00.668.319c.559 0 1.116-.562 1.909-1.931a17.813 17.813 0 012.469-.725 4.736 4.736 0 002 .609.809.809 0 00.616-1.359c-.434-.425-1.7-.3-2.3-.225zm4.281-7.087L8.719.219A.749.749 0 008.188 0H8v4h4v-.191a.748.748 0 00-.219-.528zm-2.315 7.977c.128-.084-.078-.372-1.338-.281 1.16.494 1.338.281 1.338.281z"
                                                      data-name="Icon awesome-file-pdf"
                                                      transform="translate(9 7)"
                                                    ></path>
                                                  </svg>
                                                </button>
                                              ) : module.type === "ppt" ? (
                                                <button className="button-reset">
                                                  <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="30"
                                                    height="30"
                                                    viewBox="0 0 30 30"
                                                  >
                                                    <defs>
                                                      <linearGradient
                                                        id="linear-gradient"
                                                        x2="1"
                                                        y1="0.5"
                                                        y2="0.5"
                                                        gradientUnits="objectBoundingBox"
                                                      >
                                                        <stop
                                                          offset="0"
                                                          stopColor="#6941C6"
                                                        ></stop>
                                                        <stop
                                                          offset="1"
                                                          stopColor="#ed156e"
                                                        ></stop>
                                                      </linearGradient>
                                                    </defs>
                                                    <circle
                                                      cx="15"
                                                      cy="15"
                                                      r="15"
                                                      fill="url(#linear-gradient)"
                                                      data-name="Ellipse 180"
                                                    ></circle>
                                                    <circle
                                                      cx="13"
                                                      cy="13"
                                                      r="13"
                                                      fill="#fff"
                                                      data-name="Ellipse 181"
                                                      transform="translate(2 2)"
                                                    ></circle>
                                                    <path
                                                      fill="#6941C6"
                                                      d="M5.684 8a3.015 3.015 0 01-.062-1.466c.262.003.237 1.157.062 1.466zm-.053 1.478a14.42 14.42 0 01-.887 1.959 11.507 11.507 0 011.966-.684 4.048 4.048 0 01-1.079-1.275zm-2.941 3.9c0 .025.412-.169 1.091-1.256a4.319 4.319 0 00-1.09 1.256zM7.75 5H12v10.25a.748.748 0 01-.75.75H.75a.748.748 0 01-.75-.75V.75A.748.748 0 01.75 0H7v4.25a.752.752 0 00.75.75zm-.25 5.369a3.136 3.136 0 01-1.334-1.681 4.492 4.492 0 00.194-2.006.783.783 0 00-1.494-.213 5.2 5.2 0 00.253 2.406 29.344 29.344 0 01-1.275 2.681h-.006c-.847.434-2.3 1.391-1.7 2.125a.971.971 0 00.668.319c.559 0 1.116-.562 1.909-1.931a17.813 17.813 0 012.469-.725 4.736 4.736 0 002 .609.809.809 0 00.616-1.359c-.434-.425-1.7-.3-2.3-.225zm4.281-7.087L8.719.219A.749.749 0 008.188 0H8v4h4v-.191a.748.748 0 00-.219-.528zm-2.315 7.977c.128-.084-.078-.372-1.338-.281 1.16.494 1.338.281 1.338.281z"
                                                      data-name="Icon awesome-file-pdf"
                                                      transform="translate(9 7)"
                                                    ></path>
                                                  </svg>
                                                </button>
                                              ) : (
                                                <button className="button-reset">
                                                  <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="30"
                                                    height="30"
                                                    viewBox="0 0 30 30"
                                                  >
                                                    <defs>
                                                      <linearGradient
                                                        id="linear-gradient"
                                                        x2="1"
                                                        y1="0.5"
                                                        y2="0.5"
                                                        gradientUnits="objectBoundingBox"
                                                      >
                                                        <stop
                                                          offset="0"
                                                          stopColor="#6941C6"
                                                        ></stop>
                                                        <stop
                                                          offset="1"
                                                          stopColor="#ed156e"
                                                        ></stop>
                                                      </linearGradient>
                                                    </defs>
                                                    <circle
                                                      cx="15"
                                                      cy="15"
                                                      r="15"
                                                      fill="url(#linear-gradient)"
                                                      data-name="Ellipse 180"
                                                    ></circle>
                                                    <circle
                                                      cx="13"
                                                      cy="13"
                                                      r="13"
                                                      fill="#fff"
                                                      data-name="Ellipse 181"
                                                      transform="translate(2 2)"
                                                    ></circle>
                                                    <path
                                                      fill="#6941C6"
                                                      d="M5.684 8a3.015 3.015 0 01-.062-1.466c.262.003.237 1.157.062 1.466zm-.053 1.478a14.42 14.42 0 01-.887 1.959 11.507 11.507 0 011.966-.684 4.048 4.048 0 01-1.079-1.275zm-2.941 3.9c0 .025.412-.169 1.091-1.256a4.319 4.319 0 00-1.09 1.256zM7.75 5H12v10.25a.748.748 0 01-.75.75H.75a.748.748 0 01-.75-.75V.75A.748.748 0 01.75 0H7v4.25a.752.752 0 00.75.75zm-.25 5.369a3.136 3.136 0 01-1.334-1.681 4.492 4.492 0 00.194-2.006.783.783 0 00-1.494-.213 5.2 5.2 0 00.253 2.406 29.344 29.344 0 01-1.275 2.681h-.006c-.847.434-2.3 1.391-1.7 2.125a.971.971 0 00.668.319c.559 0 1.116-.562 1.909-1.931a17.813 17.813 0 012.469-.725 4.736 4.736 0 002 .609.809.809 0 00.616-1.359c-.434-.425-1.7-.3-2.3-.225zm4.281-7.087L8.719.219A.749.749 0 008.188 0H8v4h4v-.191a.748.748 0 00-.219-.528zm-2.315 7.977c.128-.084-.078-.372-1.338-.281 1.16.494 1.338.281 1.338.281z"
                                                      data-name="Icon awesome-file-pdf"
                                                      transform="translate(9 7)"
                                                    ></path>
                                                  </svg>
                                                </button>
                                              )}
                                          </span>
                                        </a>
                                      </span>
                                    </div>
                                  </>
                                </div>
                              </ul>
                            );
                          })
                        ) : (
                          <div className="module-list no-found-msg">
                            There are no Resources in this course.
                          </div>
                        )}
                        {/* <div className="jba-toolkit-module-item d-flex justify-content-between align-items-center mb-2 help-text">
                                                <div className="content">Help</div>
                                                <div className="icon cursor-pointer">
                                                    <button className="button-reset">
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width="30"
                                                            height="30"
                                                            viewBox="0 0 30 30"
                                                        >
                                                            <defs>
                                                                <linearGradient
                                                                    id="linear-gradient"
                                                                    x2="1"
                                                                    y1="0.5"
                                                                    y2="0.5"
                                                                    gradientUnits="objectBoundingBox"
                                                                >
                                                                    <stop offset="0" stopColor="#6941C6"></stop>
                                                                    <stop offset="1" stopColor="#ed156e"></stop>
                                                                </linearGradient>
                                                            </defs>
                                                            <circle
                                                                cx="15"
                                                                cy="15"
                                                                r="15"
                                                                fill="url(#linear-gradient)"
                                                                data-name="Ellipse 180"
                                                            ></circle>
                                                            <circle
                                                                cx="13"
                                                                cy="13"
                                                                r="13"
                                                                fill="#fff"
                                                                data-name="Ellipse 181"
                                                                transform="translate(2 2)"
                                                            ></circle>
                                                            <path
                                                                fill="#6941C6"
                                                                d="M7 0l7 10H0z"
                                                                data-name="Polygon 4"
                                                                transform="rotate(90 6.5 14.5)"
                                                            ></path>
                                                        </svg>
                                                    </button>
                                                    
                                                </div>
                                            </div> */}
                      </div>
                      {/* <div className="jba-toolkit-module-item d-flex justify-content-between align-items-center mb-2">
                                            <div className="content">Glossary</div>
                                            <div className="icon cursor-pointer">
                                                <button className="button-reset">
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="30"
                                                        height="30"
                                                        viewBox="0 0 30 30"
                                                    >
                                                        <defs>
                                                            <linearGradient
                                                                id="linear-gradient"
                                                                x2="1"
                                                                y1="0.5"
                                                                y2="0.5"
                                                                gradientUnits="objectBoundingBox"
                                                            >
                                                                <stop offset="0" stopColor="#6941C6"></stop>
                                                                <stop offset="1" stopColor="#ed156e"></stop>
                                                            </linearGradient>
                                                        </defs>
                                                        <circle
                                                            cx="15"
                                                            cy="15"
                                                            r="15"
                                                            fill="url(#linear-gradient)"
                                                            data-name="Ellipse 180"
                                                        ></circle>
                                                        <circle
                                                            cx="13"
                                                            cy="13"
                                                            r="13"
                                                            fill="#fff"
                                                            data-name="Ellipse 181"
                                                            transform="translate(2 2)"
                                                        ></circle>
                                                        <path
                                                            fill="#6941C6"
                                                            d="M5.684 8a3.015 3.015 0 01-.062-1.466c.262.003.237 1.157.062 1.466zm-.053 1.478a14.42 14.42 0 01-.887 1.959 11.507 11.507 0 011.966-.684 4.048 4.048 0 01-1.079-1.275zm-2.941 3.9c0 .025.412-.169 1.091-1.256a4.319 4.319 0 00-1.09 1.256zM7.75 5H12v10.25a.748.748 0 01-.75.75H.75a.748.748 0 01-.75-.75V.75A.748.748 0 01.75 0H7v4.25a.752.752 0 00.75.75zm-.25 5.369a3.136 3.136 0 01-1.334-1.681 4.492 4.492 0 00.194-2.006.783.783 0 00-1.494-.213 5.2 5.2 0 00.253 2.406 29.344 29.344 0 01-1.275 2.681h-.006c-.847.434-2.3 1.391-1.7 2.125a.971.971 0 00.668.319c.559 0 1.116-.562 1.909-1.931a17.813 17.813 0 012.469-.725 4.736 4.736 0 002 .609.809.809 0 00.616-1.359c-.434-.425-1.7-.3-2.3-.225zm4.281-7.087L8.719.219A.749.749 0 008.188 0H8v4h4v-.191a.748.748 0 00-.219-.528zm-2.315 7.977c.128-.084-.078-.372-1.338-.281 1.16.494 1.338.281 1.338.281z"
                                                            data-name="Icon awesome-file-pdf"
                                                            transform="translate(9 7)"
                                                        ></path>
                                                    </svg>
                                                </button>                                             
                                            </div>
                                        </div> */}
                      {/* <div className="jba-toolkit-module-item d-flex justify-content-between align-items-center mb-2">
                                            <div className="content">Help</div>
                                            <div className="icon cursor-pointer">
                                                <button className="button-reset">
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="30"
                                                        height="30"
                                                        viewBox="0 0 30 30"
                                                    >
                                                        <defs>
                                                            <linearGradient
                                                                id="linear-gradient"
                                                                x2="1"
                                                                y1="0.5"
                                                                y2="0.5"
                                                                gradientUnits="objectBoundingBox"
                                                            >
                                                                <stop offset="0" stopColor="#6941C6"></stop>
                                                                <stop offset="1" stopColor="#ed156e"></stop>
                                                            </linearGradient>
                                                        </defs>
                                                        <circle
                                                            cx="15"
                                                            cy="15"
                                                            r="15"
                                                            fill="url(#linear-gradient)"
                                                            data-name="Ellipse 180"
                                                        ></circle>
                                                        <circle
                                                            cx="13"
                                                            cy="13"
                                                            r="13"
                                                            fill="#fff"
                                                            data-name="Ellipse 181"
                                                            transform="translate(2 2)"
                                                        ></circle>
                                                        <path
                                                            fill="#6941C6"
                                                            d="M7 0l7 10H0z"
                                                            data-name="Polygon 4"
                                                            transform="rotate(90 6.5 14.5)"
                                                        ></path>
                                                    </svg>
                                                </button>
                                               

                                            </div>
                                        </div> */}
                    </div>
                  </div>
                ) : (
                  ""
                )}

                <div
                  className={
                    activeTab === 3 ? "note-display-show" : "note-display-hide"
                  }
                  id="my-favourites"
                  role="tabpanel"
                  aria-labelledby="fav-tab"
                >
                  <ModuleFav
                    onPostMessage={handlePostMessage}
                    favInteractive={insertFavRecord}
                    currentModuleData={selectedModule}
                    moduleId={moduleId}
                    courseCode={courseCode}
                  />
                </div>

                <div
                  className={
                    activeTab === 4 ? "note-display-show" : "note-display-hide"
                  }
                  id="notes"
                  role="tabpanel"
                  aria-labelledby="notes-tab"
                >
                  {/* <h5 style={{ color: "black", padding: "0px 35px" }}>My Notes Section</h5> */}
                  <ModuleNotes
                    onPostMessage={handlePostMessage}
                    moduleId={moduleId}
                    interactive={insertNoteRecord}
                    notesList={notesList}
                    currentModuleData={selectedModule}
                    courseCode={courseCode}
                  />
                </div>
              </div>
            </div>


            {/* <a href={`/moduleDetail/${location?.state?.courseId}`} className="card-link"
                        onClick={() => { <CourseListBody /> }}>

                        <i className="fa fa-long-arrow-left" aria-hidden="true"></i></a> */}
            <h3 className="text-white" id="courseTitle">
              {courseTitle}
            </h3>
            {/* <section className=" video_img">
                        <div className="container">
                            <div className="text-white ">
                                <h1>{courseTitle}</h1>

                            </div>
                        </div>
                    </section> */}
          </div>
          {/* <div>
                    <i className="fa fa-paper-plane" aria-hidden="true"></i>
                    <i className="fa fa-sticky-note" aria-hidden="true"></i>
                    <i className="fa fa-heart" aria-hidden="true"></i>
                    <i className="fa fa-long-arrow-right" aria-hidden="true"></i>
                </div> */}
        </div>
        <ProgressBar
          variant={selectedModule?.progress < 100 ? "warning" : "#00B70E"}
          className={`progress-launch ${isMobile ? "sticky-top-mobile" : "stick-top"}`}
          now={selectedModule?.progress}
        />
        
        {
          ( !showNextCourse || isLastRecord?
            <div id="idModuleComp" className="container mt-4" aria-hidden="false">
              <div>
                <ModuleComp
                  purchasedInfo={purchasedInfo || {}}
                  refer={iframeRef}
                  mId={moduleId}
                  courseId={location?.state?.courseId}
                  fetchDataFromIframe={fetchDataFromIframe}
                  openFavourites={openFavourites}
                  isMobile={isMobile}
                  source={source}
                  activeTab={activeTab}
                  setActiveTab={setActiveTab}
                  moduleInfo={selectedModule}
                  setIsLoad={setIsLoad}
                  isLoad={isLoad}
                  isModuleChange={isModuleChange}
                  reload={reload}
                  setIsLoading={setIsLoading}
                />
              </div>

              {source === "broker" && ['pdf'].includes(selectedModule?.rsp_scromdata[0]?.type) ? <div className="text-end mb-3"><button
                className="btn btn-primary btn-block next-course-btn"
                style={{ 'margin-right': '20px' }}
                disabled={
                  parseInt(selectedModule?.progress) === 100 ? true : false
                }
                onClick={() => {
                  if (isLoggedIn) {
                    setIsLoading(true)
                    markModuleProgressFunc(moduleId, selectedModule?.crs);
                  }
                }}
              >
                Mark as complete {/*<i className="fa fa-angle-right"></i>*/}
              </button></div> : ""}
              {moduleData &&
                moduleData?.modules &&
                moduleData?.modules[moduleData?.modules.length - 1].module_id !==
                moduleId &&
                selectedModulePos + 1 < moduleData.modules.length ? (
                <div className="container">
                  <div className=" row mb-5" aria-hidden="false">
                    <hr className="sepbtnse" />
                    <div className=" d-flex justify-content-end cong">

                      <div className="text-center border-info">
                        {parseInt(selectedModule?.progress) != 100 ? (
                          "You must complete all activities in this module before continuing."
                        ) :
                          ((!_.isEmpty(selectedModule?.rsp_scromdata)) && ((selectedModule?.rsp_scromdata[0]?.type?.toLowerCase() === "mov") ||
                            (selectedModule?.rsp_scromdata[0].type.toLowerCase() === "mp4") ||
                            (selectedModule?.rsp_scromdata[0].type.toLowerCase() === "pdf") ||
                            (selectedModule?.rsp_scromdata[0].type.toLowerCase() === "docx") ||
                            (selectedModule?.rsp_scromdata[0].type.toLowerCase() === "xlsx") ||
                            (selectedModule?.rsp_scromdata[0].type.toLowerCase() === "pptx"))
                          ) ? "" : (
                            <div className="next-learn-items">
                              {" "}
                              <span>
                                {"Congratulations on completing "}
                                <b>
                                  {moduleData.modules[selectedModulePos]?.title + "!"}
                                </b>
                              </span>
                            </div>
                          )}
                        {parseInt(selectedModule?.progress) != 100 ? (
                          ""
                        ) : (
                          <div className="next-learn-item">
                            <span>
                              {"Select Continue to proceed to "}
                              <b>
                                {moduleData.modules[selectedModulePos + 1]?.title}.
                              </b>
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                    {
                      (isPaid && hasTeaser) ?
                        ""
                        // <div className="d-flex justify-content-end mt-4 next-btn-center" id="nextButon">
                        //   <button
                        //     className="btn btn-primary btn-block next-course-btn"
                        //     disabled={
                        //       parseInt(selectedModule?.progress) < 100 ? true : false
                        //     }
                        //     onClick={() => {
                        //       nextModule();
                        //     }}
                        //   >
                        //     Continue <i className="fa fa-angle-right"></i>
                        //   </button>
                        // </div>
                        :
                        <div className="d-flex justify-content-end mt-4 next-btn-center" id="nextButon">
                          <button
                            className="btn btn-primary btn-block next-course-btn"
                            disabled={
                              parseInt(selectedModule?.progress) < 100 ? true : false
                            }
                            onClick={() => {
                              nextModule();
                            }}
                          >
                            Continue <i className="fa fa-angle-right"></i>
                          </button>
                        </div>}
                  </div>
                </div>
              ) : (
                ""
              )}

              {/* <CongPopupAnimation/> */}
            </div>
            :showLPLearnMore
              ?
              <div className="container sec-II mt-4">
                <div class="row ">
                  <LPdetailComp contentList={learningPathData?.coursesList}
                    lpDetail={learningPathData}
                    showShimmer={showShimmer}
                    is_learn_more={true}
                    fromPage={"lp"}
                    isMobile={isMobile}
                  />
                </div>
              </div>
              :
              via_cat === 'true'
                ?
                <div className="container mt-4">
                  <div className="related-video-section">
                    <div className="relate-title-sec">
                      <h4 className="titlebox">
                        There's more to Learn
                      </h4>
                      <div className="smalltext-videolist">
                        Here are some Related Courses
                      </div>
                      <div className="row mt-4">
                        <CourseCardListBody
                          key={1}
                          pageType={'course'}
                          coursesList={courseListingData}  //course.courseList
                          setFavoriteCourse={() => { }}
                          closeModal={() => { }}
                          setCloseModal={() => { }}
                          hasDescription={false}
                          filterData={''}
                          isMobile={isMobile}
                        />
                      </div>
                    </div>
                  </div>

                </div>
                : ""
          )}
        {!isMobile}
        {(isShowCongrat && moduleData?.progress !== 100) ?  //isShowCongrat
          <>
            <CongPopupAnimation title={(via_lp==="true" || from === "lp") && isLPCompleted ?moduleData.lp_name:moduleData?.courseName}
              lpPoints={moduleData?.learning_points}
              fromPage={isLPCompleted ? 2 : isFree ? 0 : 1}
              name={"course"}
              setIsAnimCompleted={setIsAnimCompleted} 
              via_lp={via_lp}
              lp_id={lp_id}
              isMobile={isMobile}
              />
          </>
          : ""}
      </div>
      {show && <AfterCongratulationsModal show={show}
        setShow={setShow}
        rank={newRank} isMobile={isMobile}/>}
    </>
  );
};
export default CourseLaunchSection;


